import Swiper from "swiper";
import { A11y, Autoplay, Scrollbar } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-upcomingevents").forEach((el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Scrollbar],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 500,
    freeMode: true,
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 2,
        spaceBetween: 36,
      },
    },
  });

  swiper.autoplay.stop();

  const start = () => {
    swiper.autoplay.start();
  };

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.update();
        start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
